// An open tab keeps running the bundle it loaded, however many publishes happen after it, and
// that bundle can call API routes a later release removed. The service worker can't help: it
// caches nothing, and the browser only checks it for updates on a full page load.
export async function isNewBuildDeployed(): Promise<boolean> {
  const running = document.querySelector<HTMLScriptElement>('script[src*="/static/js/main."]');
  // `npm start` serves bundle.js, which has no hash to compare.
  if (!running) return false;

  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/asset-manifest.json`, { cache: 'no-store' });
    if (!response.ok) return false;
    const manifest = await response.json();
    const deployed: string | undefined = manifest?.files?.['main.js'];
    return !!deployed && deployed !== new URL(running.src).pathname;
  } catch {
    return false;
  }
}

const HOUR_MS = 60 * 60 * 1000;
// Brasília has had no DST since 2019, so BRT is a fixed UTC-3.
const BRT_OFFSET_MS = -3 * HOUR_MS;
const CHECK_WINDOW_MS = 12 * HOUR_MS;

// Numbers the half-days 0h–12h and 12h–0h BRT, so a tab checks for a new build once in each.
export function buildCheckWindow(now = Date.now()): number {
  return Math.floor((now + BRT_OFFSET_MS) / CHECK_WINDOW_MS);
}
